<template>
  <b-overlay :show="isLoading">
    <div class="rounded-lg bg-white d-flex p-3 align-items-center">
      <div>
        <h5>Only include matches in metrics</h5>
        <p>If we can't match your data with a visitor, you can optionally choose to mark this data as 'void' - this will prevent unmatched data from being included in your metrics and will be hidden by default in the Hub.</p>
      </div>
      <div>
        <b-form-checkbox size="lg" :checked="installationConfig.getVoidTriggers()" @change="doUpdateValue" switch />
      </div>
    </div>
  </b-overlay>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { FormCheckboxPlugin, OverlayPlugin } from 'bootstrap-vue'
import InstallationConfigRepo from '@/repos/InstallationConfigRepo'
import InstallationConfig from '@/models/InstallationConfig'

Vue.use(FormCheckboxPlugin)
Vue.use(OverlayPlugin)

@Component
export default class VoidTriggers extends Vue {
  private installationConfig = new InstallationConfig()
  private isLoading = true

  async created () {
    const repo = new InstallationConfigRepo()
    const config = await repo.find(this.$infinityAuth.getInstallation().getId())

    if (config) {
      this.installationConfig = config
    }

    this.isLoading = false
  }

  async doUpdateValue (value: boolean) {
    this.isLoading = true

    const repo = new InstallationConfigRepo()
    await repo.updateVoidTriggers(this.$infinityAuth.getInstallation().getId(), value)

    this.installationConfig.setVoidTriggers(value)
    this.isLoading = false
  }
}
</script>
